import * as React from 'react';
import { IOrgAssetGraphItem } from '../../../../interfaces/OrgAssets/IOrgAssetGraphItem';
import { Helper } from '../../../../Helper';
import * as styles from './OrgAssetFolder.css';


export interface IAOrgAssetSubFolderProps {
  folder: IOrgAssetGraphItem;
  highlightColor: string;
  onClick: () => void;
}

export interface IAOrgAssetSubFolderState {
}

export class IAOrgAssetSubFolder extends React.Component<IAOrgAssetSubFolderProps, IAOrgAssetSubFolderState> {
  constructor(props: IAOrgAssetSubFolderProps) {
    super(props);
    this.state = {
    };
  }

  public render(): JSX.Element {
    const textColor = Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.highlightColor, "white", "black");
    return (
      <div
        className={styles.IA_OrgAssetSubFolderContainer}
      >
        <div
          className={styles.IA_OrgAssetSubFolderPolygon}
          style={{
            backgroundColor: this.props.highlightColor
          }}
          onClick={() => this.props.onClick()}
        />
        <div
          className={styles.IA_OrgAssetSubFolder}
          style={{
            backgroundColor: this.props.highlightColor
          }}
          onClick={() => this.props.onClick()}
        >
          <div
            className={styles.IA_OrgAssetSubFolderTitle}
            style={{
              color: textColor
            }}
          >
            {this.props.folder.name}
          </div>
          <div
            className={styles.IA_OrgAssetSubFolderChildCounter}
            style={{
              color: textColor
            }}
          >
            {this.props.folder.childCount}
          </div>
        </div>
      </div>
    );
  }
}
